<template>
    <div class="apprentice-simple-card pixabay-images-wrapper">
        <b-input-group class="search">
            <div class="search-wrapper">
                <b-form-input
                    v-model="search"
                    type="text"
                    @keyup.enter="getImages"
                    :placeholder="$t('pixabay.search')"></b-form-input>

                <b-input-group-append>
                    <b-button
                        class="btn-search btn-search"
                        variant="outline-primary"
                        @click="getImages">
                    </b-button>
                </b-input-group-append>
            </div>
        </b-input-group>

        <div
            class="row pixabay-images"
            v-if="images.hits && images.hits.length">
            <div
                class="col-12 col-sm-6 col-md-4 col-xl-2 pixabay-image-wrapper"
                v-for="image of images.hits">
                <div class="pixabay-image">
                    <img :src="image.previewURL" />

                    <div class="pixabay-image-info">
                        <div class="tags">{{ getTags(image) }}</div>
                        <a
                            class="btn-download btn-download-image"
                            v-b-tooltip.hover
                            title="Download"
                            variant="primary-icon"
                            :href="image.fullHDURL"
                            download
                            target="_blank">
                        </a>
                    </div>
                </div>
            </div>

            <div
                class="col-12 apprentice-pagination pixabay-images-pagination"
                v-if="images.total > 20">
                <b-pagination
                    v-model="page"
                    @change="setPagination($event)"
                    :total-rows="this.images.totalHits"
                    :per-page="20"
                    size="md"
                    first-class="go-to-first-page"
                    last-class="go-to-last-page"
                    next-class="nex-page"
                    prev-class="previous-page"
                    page-class="page">
                </b-pagination>
            </div>
            <div
                class="btn-loading clickable loading"
                v-if="loading">
                <div class="fa-3x spinner">
                    <i class="fas fa-spinner fa-spin"></i>
                </div>
            </div>
        </div>

        <div
            class="not-found with-header empty-pixabay-image-list"
            v-else>
            <div
                class="btn-loading clickable loading initial"
                v-if="loading">
                <div class="fa-3x spinner">
                    <i class="fas fa-spinner fa-spin"></i>
                </div>
            </div>

            <div
                class="icon"
                v-if="!loading">
                <i class="fas fa-exclamation-circle"></i>
            </div>
            <div
                class="alert-notice"
                v-if="!loading">
                {{ $t('pixabay.no_images_found') }}
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'design-2021-pixabay-index-component',
    data() {
        return {
            images: [],
            search: '',
            page: 1,
            loading: false,
        };
    },
    methods: {
        setPagination(page) {
            this.page = page;
            this.getImages();
        },

        getImages() {
            let data = {
                search: this.search,
                page: this.page,
            };

            this.loading = true;
            this.axios.post(this.routes.pixabayImages(), data).then(
                (response) => {
                    this.loading = false;
                    this.images = response.data;
                },
                (error) => {
                    this.alert.ajaxError(error);
                },
            );
        },

        getTags(image) {
            return image.tags ? image.tags.split(',').join(' | ') : null;
        },
    },
    mounted() {
        this.getImages();
    },
};
</script>

<style scoped lang="scss">
.search {
    margin-bottom: map-get($grid-gutter-spacing, 'forty-two');
    border: solid 0.2rem transparent;

    input:focus {
        box-shadow: none;
    }

    .btn-search {
        font-size: 1.125rem;
        border-top-right-radius: $border-radius-content;
        border-bottom-right-radius: $border-radius-content;

        &:hover {
            color: $primary;
        }
    }

    .btn-clear-search-term,
    .btn-search {
        padding: map-get($grid-gutter-spacing, 'eight') map-get($grid-gutter-spacing, 'ten');
        background-color: $secondary-background-color;
        border: none;
        outline: none;
        box-shadow: none;

        &:before {
            margin-right: 0;
        }

        &:hover,
        &:focus {
            background-color: $secondary-background-color;
            border: none;
            outline: none;
            box-shadow: none;
        }
    }

    .search-wrapper {
        display: flex;
        border: solid 0.2rem transparent;

        input {
            margin-bottom: 0;
            border-top-right-radius: 0;
            border-bottom-right-radius: 0;
        }

        &:focus-within {
            border: solid 0.2rem rgba($primary, 25%);
            border-radius: $border-radius-content;

            .btn-search,
            .btn-clear-search-term {
                border: none;
            }
        }
    }
}

.pixabay-images {
    position: relative;
}

.pixabay-image-wrapper {
    margin-bottom: map-get($grid-gutter-spacing, 'twenty-one');
}

.pixabay-image {
    img {
        width: 100%;
        height: 175px;
        object-fit: cover;
        object-position: center;
        border-radius: $border-radius-content;
    }

    .pixabay-image-info {
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: flex-start;
        margin-top: map-get($grid-gutter-spacing, 'eight');

        .tags {
            color: $text-muted-color;
            font-weight: $font-weight-medium;
            margin-right: map-get($grid-gutter-spacing, 'eight');
        }

        .btn-download-image {
            align-self: flex-start;
            font-size: $default-font-size;
            padding: map-get($grid-gutter-spacing, 'eight') map-get($grid-gutter-spacing, 'ten');
            margin-left: auto;

            &:before {
                margin-right: 0;
            }
        }
    }
}

.pixabay-images-pagination {
    display: flex;
    align-items: center;
    justify-content: center;
}

.loading {
    &:not(.initial) {
        background-color: rgba(0, 0, 0, 0.3);
    }

    .spinner {
        display: flex;
        align-items: center;
        justify-content: center;
        top: 33%;
        position: relative;
        font-size: 2.75rem;
        color: $primary;
    }
}

.empty-pixabay-image-list {
    min-height: 250px;
    position: relative;
}

@media (min-width: map-get($grid-breakpoints, 'md')) {
    .search {
        display: flex;
        justify-content: center;

        input {
            width: 350px;
            flex: 0 0 auto;
        }

        .btn-clear-search-term,
        .btn-search {
            font-size: 1.3125rem;
        }

        .btn-clear-search-term {
            &:before {
                margin-right: 0;
            }
        }
    }
}
</style>
